























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import { CloseButtonConfigVO } from "@/model/FormWheel";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
  },
})
export default class CloseButtonSetting extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  value!: CloseButtonConfigVO;

  @Prop({ type: String, default: "" })
  pageType!: string;

  @Prop({ type: String, default: "" })
  defaultIconColor!: string;

  config: CloseButtonConfigVO = {};

  get positionOptions() {
    return [
      { value: "left-top", label: this.$tx("form.edit.closePos.leftTop", "左上角") },
      { value: "right-top", label: this.$tx("form.edit.closePos.rightTop", "右上角") },
    ];
  }

  get bgModeOptions() {
    return [
      { value: "none", label: this.$tx("form.edit.bgMode.none", "无") },
      { value: "circle", label: this.$tx("form.edit.bgMode.circle", "圆形") },
      { value: "square", label: this.$tx("form.edit.bgMode.square", "方形") },
    ];
  }

  sizeOptions = [
    "18px",
    "20px",
    "22px",
    "24px",
    "26px",
    "28px",
    "30px",
    "32px",
    "34px",
    "36px",
    "38px",
    "40px",
  ].map(value => ({ value, label: value }));

  predefineColors = [
    "#000000",
    "#333333",
    "#666666",
    "#999999",
    "#CCCCCC",
    "#FFFFFF",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#FF00FF",
    "#00FFFF",
    "#C30D23",
    "#0F1222",
    "#513EFF",
    "rgba(0,0,0,0)",
    "rgba(0,0,0,0.5)",
    "rgba(255,255,255,0.8)",
  ];

  get iconColorDefault(): string {
    return this.defaultIconColor || "#333333";
  }

  get defaultConfig(): CloseButtonConfigVO {
    return {
      position: "right-top",
      bgMode: "none",
      bgColor: "rgba(0,0,0,0)",
      iconColor: this.iconColorDefault,
      size: "18px",
    };
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange() {
    this.initConfig();
  }

  @Watch("defaultIconColor", { immediate: true })
  onDefaultIconColorChange() {
    if (!this.value?.iconColor) {
      this.initConfig();
    }
  }

  initConfig() {
    this.config = {
      ...this.defaultConfig,
      ...this.value,
    };
  }

  handleChange() {
    this.$emit("input", { ...this.config });
    this.$emit("change", { ...this.config });
  }

  handleChangeWithGtag() {
    this.handleChange();
    window?.gtagClick?.(
      "form_edit_setCloseButtonSize",
      `弹窗_编辑订阅工具_设置关闭按钮尺寸_${this.pageType}`
    );
  }
}
